<template>
  <div>
    <voucher-form @submit="createVoucher"
              :loading="loading">
    </voucher-form>
  </div>
</template>
<script>
  import VoucherForm from './VoucherForm'
  import VoucherService from 'src/services/VoucherService'
  export default {
    name: 'voucher-create',
    components: {
      VoucherForm
    },
    data () {
      return {
        loading: false
      }
    },
    methods: {
      async createVoucher(voucher) {
        try {
          this.loading = true
          await VoucherService.create(voucher)
          this.$router.push('/ecommerce/vouchers')
        } catch (e) {
          console.warn(e)
        }
        this.loading = false
      }
    }
  }
</script>
<style>
</style>
